import { EllipsisOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu } from 'antd';
import React from 'react';
import { FC, useMemo, ReactElement } from 'react';

import styles from './MenuRenderer.module.less';

export interface MenuItem {
  label: string;
  icon: ReactElement;
  isEnabled: boolean;
  onClick: (moleculeId: string) => void;
}

interface MenuRendererProps {
  menu: (moleculeId: string) => MenuItem[] | MenuItem[];
}

export const MenuRenderer: FC<MenuRendererProps> = ({ menu }) => {
  const menuItems = useMemo(() => {
    if (Array.isArray(menu)) {
      return menu;
    }

    return menu('1');
  }, [menu]);

  return (
    <div className={styles.menuRenderer}>
      <Dropdown
        overlay={
          <>
            <Menu selectable={false}>
              {menuItems.map((item, index) => (
                <Menu.Item
                  key={item.label}
                  disabled={!item.isEnabled}
                  onClick={() => item.onClick(index)}
                >
                  {item.icon} {item.label}
                </Menu.Item>
              ))}
            </Menu>
          </>
        }
        trigger={['click']}
      >
        <Button
          className={styles.menuBtn}
          icon={<EllipsisOutlined />}
          shape="circle"
          type="text"
        />
      </Dropdown>
    </div>
  );
};

export interface MenuOverlayProps {
  menu: (moleculeId: string) => MenuItem[];
}

export const MenuOverlay: FC<MenuOverlayProps> = ({ menu }) => {
  return (
    <div className={styles.menuOverlay}>
      <MenuRenderer menu={menu} />
    </div>
  );
};
